export default __webpack_public_path__ + "static/media/sidebar-background.9d9cfd3b.jpg";